import { ReorderConfirmLocationScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <ReorderConfirmLocationScreen />;
}
